/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const PERMISSION_FRAGMENT = gql`
  fragment Permission on DAIPermission {
    id
    category
    name
    codename
  }
`
